import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Kakao } from "../kakao/Kakao";
import Footer from "./Footer";
import Header from "./Header";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, setShowLoginModal } = useAuth();
  useEffect(() => {
    const handleOpenModalEvent = () => {
      console.log("openLoginModal event received");
      setShowLoginModal(true);
    };

    document.addEventListener("openLoginModal", handleOpenModalEvent);

    return () => {
      document.removeEventListener("openLoginModal", handleOpenModalEvent);
    };
  }, [setShowLoginModal]);
  const { pathname } = useLocation();
  const noHeader = !!pathname?.startsWith("/p/");
  return (
    <div className="flex flex-col justify-between sm:min-h-[100vh]">
      {!noHeader && <Header />}
      <main className="mb-10 lg:pt-[6.375rem]">{children}</main>
      {!noHeader && <Footer />}
      {/* {!noHeader && <Kakao />} */}
      <Kakao />
    </div>
  );
};

export default Layout;
